<template>
  <div class="row">
    <!-- User Card -->
    <div class="col-xl-4 col-lg-5 col-md-6">
      <div class="iphone-x">
        <div v-if="!iframeLoaded" class="progress-container">
          <div class="progress">
            <div class="progress-bar" role="progressbar" :style="{ width: loadingProgress + '%' }" :aria-valuenow="loadingProgress" aria-valuemin="0" aria-valuemax="100">
              {{ loadingProgress }}%
            </div>
          </div>
        </div>
        <div class="iframe-container" v-show="iframeLoaded">
          <iframe :src="qrUserUrl" title="User QR Profile" @load="onIframeLoad" ref="userIframe"></iframe>
        </div>
      </div>
    </div>
    <div class="col-xl-8 col-lg-7 col-md-6">
      <card class="card" :title="$t('profile_edit_preview.editProfilePreview')">
        <div>
          <form>
            <div class="row">
              <div class="col-md-3">
                <b-form-checkbox v-model="top_info_set.background_img_status" round @click.native.prevent="topInfoSet('background_img_status')">
                  {{ $t('profile_edit_preview.backgroundImage') }}
                </b-form-checkbox>
              </div>
              <div class="col-md-3">
                <b-form-checkbox v-model="top_info_set.profile_img_status" round @click.native.prevent="topInfoSet('profile_img_status')">
                  {{ $t('profile_edit_preview.profileImage') }}
                </b-form-checkbox>
              </div>
              <div class="col-md-2">
                <b-form-checkbox v-model="top_info_set.profile_name_status" round @click.native.prevent="topInfoSet('profile_name_status')">
                  {{ $t('profile_edit_preview.name') }}
                </b-form-checkbox>
              </div>
              <div class="col-md-2">
                <b-form-checkbox v-model="top_info_set.company_status" round @click.native.prevent="topInfoSet('company_status')">
                  {{ $t('profile_edit_preview.company') }}
                </b-form-checkbox>
              </div>
              <div class="col-md-2">
                <b-form-checkbox v-model="top_info_set.title_status" round @click.native.prevent="topInfoSet('title_status')">
                  {{ $t('profile_edit_preview.title') }}
                </b-form-checkbox>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-md-3">
                <b-form-checkbox v-model="top_info_set.button_call" round @click.native.prevent="topInfoSet('button_call')">
                  <h5 class="ti-mobile text-center"></h5>
                  <h6 class="text-truncate">{{ $t('profile_edit_preview.call') }}</h6>
                </b-form-checkbox>
              </div>
              <div class="col-md-3">
                <b-form-checkbox v-model="top_info_set.button_add" round @click.native.prevent="topInfoSet('button_add')">
                  <h5 class="ti-user text-center"></h5>
                  <h6 class="text-truncate">{{ $t('profile_edit_preview.add') }}</h6>
                </b-form-checkbox>
              </div>
              <div class="col-md-3">
                <b-form-checkbox v-model="top_info_set.button_bank" round @click.native.prevent="topInfoSet('button_bank')">
                  <h5 class="ti-money text-center"></h5>
                  <h6 class="text-truncate">{{ $t('profile_edit_preview.bank') }}</h6>
                </b-form-checkbox>
              </div>
              <div class="col-md-3">
                <b-form-checkbox v-model="top_info_set.button_location" round @click.native.prevent="topInfoSet('button_location')">
                  <h5 class="ti-location-arrow text-center"></h5>
                  <h6 class="text-truncate">{{ $t('profile_edit_preview.location') }}</h6>
                </b-form-checkbox>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-12">
                <card class="card-plain">
                  <table class="table table-striped tableClass">
                    <thead></thead>
                    <tbody>
                    <tr v-for="(item, index) in userCards" :key="index">
                      <td><img style="width: 25px" :src="`${imageUrl}/icons/${item.file}`" /></td>
                      <td>{{ item.title }}</td>
                      <td class="col-2">
                        <b-form-checkbox v-model="item.status" name="checkbox" value="true" unchecked-value="false" round @click.native.prevent="showHideIcon(index)">
                          {{ item.status ? $t('profile_edit_preview.show') : $t('profile_edit_preview.hide') }}
                        </b-form-checkbox>
                      </td>
                      <p-button type="danger" round @click.native.prevent="removeCards(index)" class="text-center ti-trash"></p-button>
                    </tr>
                    </tbody>
                  </table>
                </card>
              </div>
            </div>
          </form>
        </div>
        <div class="text-center">
          <p-button type="info" round @click.native.prevent="updateProfile">
            {{ $t('profile_edit_preview.update') }}
          </p-button>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import config from "@/routing_map.json";
import router from "@/router";
import NotificationTemplate from "@/pages/Notifications/NotificationTemplate";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { BFormCheckbox } from 'bootstrap-vue';
export default {
  components: {
    vSelect,
    BFormCheckbox,
  },
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log('slide change');
    };
    return {
      onSwiper,
      onSlideChange,
    };
  },
  data() {

    return {
      user: {
        company: "",
        name: "",
        surname: "",
        address: "",
        title: "",
      },
      top_info_set:{
        background_img_status: true,
        profile_img_status: true,
        company_status: true,
        title_status: true,
        profile_name_status: true,
        button_call: true,
        button_add: true,
        button_bank: true,
        button_location: true,
      },
      userCards: [],
      cards: [],
      cardPreviewSetting:{
        swipeNone:false,
        swipeVertical: true,
        swipeHorizontal: false,
      },
      editing_index: null,
      cardTitle: null,
      cardAddress: null,
      profileImageSrc: null,
      backgroundImageSrc: null,
      eCatalog: null,
      imagePreview: false,
      imageUrl: null,
      selectedCardItem: null,
      userCustomIconPreview : false,
      userCustomIcon : null,
      userCustomIconSrc : null,
      catalogUpCheck: false,
      userIconCheck: false,
      topInfoCheck: false,
      qrUserUrl:"onlinecardvisit.com",
      iframeLoaded: false,
      loadingProgress: 0,
      loadingInterval: null,
    };
  },
  watch: {
    selectedCardItem() {
      if(this.selectedCardItem){
        switch (this.selectedCardItem.name){
          case "catalog":
            this.catalogUpCheck = true
            this.userIconCheck = false
            break;
          case "custom":
            this.userIconCheck = true
            this.catalogUpCheck = false
            break;
          default:
            this.catalogUpCheck = false
            this.userIconCheck = false

        }
      }else {
        this.catalogUpCheck = false
        this.userIconCheck = false
      }

    },
    userCustomIcon(newValue, oldValue) {
      if (!this.userCustomIconPreview && (newValue !== oldValue)) {
        if (newValue) {
          base64Encode(newValue)
            .then(value => {
              this.userCustomIconSrc = value
            })
            .catch(() => {
              this.userCustomIconSrc = null
            })

        } else {
          this.userCustomIconSrc = null
        }
      }

    },
  },
  mounted() {
    this.getCustomer()
    this.getCards()
    this.startLoadingAnimation();
  },
  methods: {
    startLoadingAnimation() {
      this.loadingProgress = 0;
      this.loadingInterval = setInterval(() => {
        if (this.loadingProgress < 90) {
          this.loadingProgress += 10;
        }
      }, 200);
    },

    onIframeLoad() {
      clearInterval(this.loadingInterval);
      this.loadingProgress = 100;
      setTimeout(() => {
        this.iframeLoaded = true;
      }, 200);
    },

    updateProfileAndReloadIframe() {
      this.updateProfile();
      this.reloadIframe();
    },

    reloadIframe() {
      this.iframeLoaded = false;
      this.startLoadingAnimation();
      if (this.$refs.userIframe) {
        this.$refs.userIframe.src = this.qrUserUrl;
      }
    },
    onSwiper (swiper) {
      console.log(swiper)
    },
    onSlideChange () {
      console.log('slide change')
    },
    getCards() {
      const app_data = this
      // eslint-disable-next-line camelcase
      axios.defaults.headers.common.authorization = localStorage.getItem('authorization')
      axios.get(
        `${config.app_url}/user/get-cards`,
      ).then(response => {
        if (response.data.success) {
          app_data.cards = response.data.msg.data

        } else {
          app_data.notifyVue('top', 'right', "Data Not Get!", "warning")
        }
      }).catch(error => {
        router.push('login')
        app_data.notifyVue('top', 'right', "Connection Error!", "warning")
      })
    },

    updateProfile() {
      const app_data = this
      // eslint-disable-next-line camelcase
      axios.defaults.headers.common.authorization = localStorage.getItem('authorization')
      axios.post(
        `${config.app_url}/user/update-user-card`,
        {cards_info:app_data.userCards,cardPreviewSetting:app_data.cardPreviewSetting,top_info_set:app_data.top_info_set}
      ).then(response => {
        if (response.data.success) {
          app_data.notifyVue('top', 'right', "Güncelleme Başarılı!", "success")
          this.reloadIframe();
        } else {
          app_data.notifyVue('top', 'right', "Güncelleme Başarısız!", "warning")
        }
      }).catch(error => {
        app_data.notifyVue('top', 'right', "Bağlantı Hatası!", "warning")
      })
    },
    getCustomer() {
      const app_data = this
      // eslint-disable-next-line camelcase
      axios.defaults.headers.common.authorization = localStorage.getItem('authorization')
      axios.get(
        `${config.app_url}/user/get-user`,
      ).then(response => {
        if (response.data.success) {
          app_data.user = response.data.msg
          app_data.userCards = response.data.msg.cards_info
          app_data.top_info_set = response.data.msg.top_info_set
          app_data.cardPreviewSetting = response.data.msg.cardPreviewSetting
          app_data.imageUrl = `${config.img_url}`
          response.data.msg.background_img ? app_data.backgroundImageSrc = `${config.img_url}/${response.data.msg.background_img}` : app_data.backgroundImageSrc = "@/assets/img/background.jpg"
          response.data.msg.profile_img ? app_data.profileImageSrc = `${config.img_url}/${response.data.msg.profile_img}` : app_data.profileImageSrc = "@/assets/img/faces/face-2.jpg"
          app_data.qrUserUrl = `${config.qr_url}/qr-user/?hash=${response.data.msg.userHash}`;
        } else {

        }
      }).catch(error => {
        router.push('login')
        app_data.$toast.error(error.toString());
      })
    },
    notifyVue(verticalAlign, horizontalAlign, message, type) {
      this.$notify({
        component: NotificationTemplate,
        title: message,
        icon: "info",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
        duration: 2000
      });
    },
    addCard() {
      if (this.selectedCardItem && this.editing_index == null) {
        this.userCards.push({title: this.cardTitle, address: this.cardAddress, file: this.selectedCardItem.file})
      } else if (this.editing_index != null) {
        this.userCards[this.editing_index].title = this.cardTitle;
        this.userCards[this.editing_index].address = this.cardAddress;
        this.userCards[this.editing_index].file = this.selectedCardItem.file;
      }
      this.cardTitle = null;
      this.cardAddress = null;
      this.selectedCardItem = null;
    },
    editCards(index) {
      this.editing_index = index;
      this.cardTitle = çç.title
      this.cardAddress = this.userCards[index].address
      this.selectedCardItem = this.cards.find(x => x.file == this.userCards[index].file)
    },
    removeCards(index) {
      this.userCards.splice(index, 1)
    },
    handleCatalogChange(event) {
      this.eCatalog = null
      this.eCatalog = event.target.files[0];
    },
    removeCatalog() {
      this.eCatalog = null
    },
    removeUserCustomIcon() {
      this.userCustomIconPreview = false
      this.userCustomIcon = null
      this.userCustomIconSrc = null
    },
    handleUserCustomIcon(event) {
      this.userCustomIconPreview = false
      this.userCustomIcon = null
      this.userCustomIcon = event.target.files[0];

    },
    showHideIcon(index) {
      this.userCards[index].status = !this.userCards[index].status
    },
    topInfoSet(value) {
      this.top_info_set[value] = !this.top_info_set[value]
    },
  },


};
const base64Encode = data => new Promise((resolve, reject) => {
  const reader = new FileReader()
  reader.readAsDataURL(data)
  reader.onload = () => resolve(reader.result)
  reader.onerror = error => reject(error)
})
</script>
<style>
/* iPhone X benzeri çerçeve */
.iphone-x {
  width: 350px;
  height: 700px;
  max-width: 375px;
  max-height: 812px;
  background: #000;
  position: relative;
  border: 16px solid #222;
  border-radius: 44px;
  overflow: hidden;
}

.iframe-container {
  width: 100%;
  height: 100%;
}

iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.progress-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
}

</style>
